import { DownOutlined } from '@ant-design/icons';
import { Button, Dropdown, Form, Input, Menu, Space, Typography } from 'antd';
import React, { useCallback, useState } from 'react';
import { TaskPriorities, TaskPriorityColors } from '../EditTask/constants';

const { Text, Title } = Typography;

function EditTaskImportance({ onSubmit, task }) {
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const onFinish = useCallback(
    async ({ key }) => {
      setError(null);
      setLoading(true);
      try {
        await onSubmit({
          importance: key,
        });
        setEditing(false);
      } catch (err) {
        console.error(err);
        setError(err.message);
      }
      setLoading(false);
    },
    [onSubmit],
  );

  return (
    <>
      <div className="status-row-title">
        <Title level={4}>Importance</Title>
      </div>
      <Dropdown
        overlay={
          <Menu onClick={onFinish}>
            {TaskPriorities.map((status) => (
              <Menu.Item key={status.value}>{status.label}</Menu.Item>
            ))}
          </Menu>
        }
        placement="bottomLeft"
        trigger="click"
      >
        <Button
          style={{
            color: TaskPriorityColors[task.importance].color,
            borderColor: TaskPriorityColors[task.importance].color,
            width: '100%',
            borderRadius: 4,
          }}
          loading={loading}
        >
          {TaskPriorityColors[task.importance].label}
          <DownOutlined />
        </Button>
      </Dropdown>
      {error && (
        <Form.Item>
          <Text type="danger">{error}</Text>
        </Form.Item>
      )}
      <style jsx>{`
        .status-row-title {
          margin-bottom: 8px;
          font-weight: 600;
        }
      `}</style>
    </>
  );
}

export default EditTaskImportance;
